import {
    ChangeDetectorRef,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { MaintenanceComponent } from './core/maintenance/maintenance.component';
import { MaintenanceService } from './core/maintenance/maintenance.service';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { DateAdapter } from '@angular/material/core';
import {
    CognitoAuthService,
    COGNITO_LOGIN_ERROR_KEY,
} from './core/auth/cognito-auth.service';
import { EventsService } from './core/services/events.service';
import { PwaService } from './core/services/pwa.service';
import { SessionSyncService } from './core/services/session-sync.service';
import { storeLanguage } from './core/transloco/language-preference';
import { ZoomLevelService } from './core/services/zoom-level.service';
import { Subscription } from 'rxjs';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de', localeDeExtra);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, MaintenanceComponent],
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [],
})
export class AppComponent implements OnInit, OnDestroy {
    langChangeSub: Subscription;

    // @HostListener('window:resize', ['$event'])
    // onResize(event) {
    //     this.zoomLevelService.changeZoom();
    // }

    constructor(
        private translocoService: TranslocoService,
        private dateAdapter: DateAdapter<Date>,
        private events: EventsService,
        private chRef: ChangeDetectorRef,
        private pwaService: PwaService,
        private zoomLevelService: ZoomLevelService,
        public maintenanceService: MaintenanceService,
        private cognitoAuthService: CognitoAuthService,
        private sessionSyncService: SessionSyncService,
        private router: Router
    ) {}

    async ngOnInit() {
        // Listen for sign-outs in other tabs before anything can await, so a
        // logout that happens during the Cognito handshake is not missed.
        this.sessionSyncService.start();
        try {
            // Memoized: the transloco loader may already have kicked this off
            // while waiting for the PHP session before fetching translations.
            const exchanged = await this.cognitoAuthService.ensureSession();
            if (exchanged) {
                this.router.navigateByUrl('/home');
            } else if (sessionStorage.getItem(COGNITO_LOGIN_ERROR_KEY)) {
                // Cognito sign-in was attempted but the backend refused it.
                // Route to the login page so the stored reason is shown.
                this.router.navigate(['/sign-in']);
            }
        } catch (error) {
            console.error('Cognito callback handling failed', error);
        }
        this.maintenanceService.startPolling();
        this.maintenanceService.startVisibilityCheck();
        this.dateAdapter.setLocale(this.translocoService.getActiveLang());
        this.langChangeSub = this.translocoService.langChanges$.subscribe(
            lang => {
                // Remember the language for the next (possibly anonymous) load,
                // so the sign-in page and the Cognito hosted UI open in the
                // language the user actually picked (HIP-43).
                storeLanguage(lang);
                if (lang === 'en') {
                    this.dateAdapter.setLocale('en-GB');
                } else {
                    this.dateAdapter.setLocale('de-DE');
                }
            }
        );
        this.events.subscribe('cdr', () => {
            this.chRef.detectChanges();
        });
        this.zoomLevelService.changeZoom();
    }

    ngOnDestroy(): void {
        this.maintenanceService.stopPolling();
        if (this.langChangeSub) {
            this.langChangeSub.unsubscribe();
        }
    }
}
